export const TIME_FILTER = {
  WITHIN_ONE_YEAR: '<1,YEAR',
  FOREVER: 'forever',
};
